import { RestService } from './../../core/rest.service';
import {
  Component,
  OnInit,
  ViewChild,
  NgZone,
  OnDestroy,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import { CommunicationService } from 'src/services/communication.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { validateAllFormFields } from 'src/utils/validateform';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'config/app.config';
import { UtilityService } from 'src/services/utility.service';
import { CustomValidators } from '../directives/custom.validator';

@Component({
  selector: 'login',
  styleUrls: ['./login.component.css'],
  templateUrl: './login.component.html',
  providers: [AuthService, RestService],
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('aboutModal', { static: true })
  public aboutModal: ModalDirective;
  @ViewChild('secretariatModal', { static: true })
  public secretariatModal: ModalDirective;
  @ViewChild('textEmail', { static: false }) textEmail!: ElementRef;
  @ViewChild('textPassword', { static: false }) textPassword!: ElementRef;
  public localState = { value: '' };
  validateEmailform: FormGroup;

  // TO MAKE RESPONSIVE
  isCollapsed: boolean = true;
  lastUrl: any;
  public auth2: any;
  googleEmail: any;
  googleToken: any;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
  };
  loginRequired: string;
  loginMinLength: string;
  loginMaxLength: string;
  loginEmailInvalid: string;
  passwordRequired: string;
  passwordMaxLength: string;
  oneTimePasswordFormGroup: FormGroup;
  isShowOtpFormGroup: boolean = false;
  isUserNotRegistered: boolean = false;
  isRegistrationRequired: boolean = false;
  registerCheckboxValue: boolean = false;
  modalRef: any;
  conferenceShortName: string;
  eventShortName: string;

  isUserAlredyExists = false;
  validatePasswordform: FormGroup;
  isShowOtpVerifyScreen;
  showInvalidOtp;
  otpValues = Array(4);
  clipData;
  email;
  verification;
  iadvlConst;
  constructor(
    private authService: AuthService,
    private router: Router,
    public ngZone: NgZone,
    public cookieService: CookieService,
    private http:HttpClient,
    private utilityService: UtilityService,
    public communicationService: CommunicationService) {
    this.lastUrl = this.cookieService.get('lastUrl');
    localStorage.removeItem('abstractData');
    localStorage.clear();
    this.deleteAllCookies();
    const iadvlConst = localStorage.getItem('iadvlConst');
    if(iadvlConst){
      this.iadvlConst = JSON.parse(iadvlConst);
    } else {
      this.getConsts();
    }
  }
  public ngOnInit() {
    this.validateEmailform = new FormGroup({
      Email: new FormControl('', [
        CustomValidators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,}$/),
      ]),
    });

    this.validatePasswordform = new FormGroup({
      Password: new FormControl('', [
        CustomValidators.required,
        Validators.maxLength(30),
      ]),
    });
    this.oneTimePasswordFormGroup = new FormGroup({
      input1: new FormControl('', [CustomValidators.required]),
      input2: new FormControl('', [CustomValidators.required]),
      input3: new FormControl('', [CustomValidators.required]),
      input4: new FormControl('', [CustomValidators.required]),
    });
    this.otpFromChanges();
  }
  public getConsts() {
    var val = Math.floor(1000 + Math.random() * 9000);
    this.http.get(`../../assets/const.json?rand=${val}`).subscribe(res => {
      if(res){
        this.iadvlConst = res;
        localStorage.setItem('iadvlConst',JSON.stringify(res));
      }
    });
  }

  setCookieAndNavigate(userId, adminAuthority, userName) {
    this.communicationService.setUserId(userId);
    this.communicationService.setAdminAuthority(adminAuthority);
    this.communicationService.setUserName(userName);
  }

  ngOnDestroy() {
    if (this.aboutModal) {
      this.aboutModal.hide();
    }
    if (this.secretariatModal) {
      this.secretariatModal.hide();
    }
  }
  public deleteAllCookies() {
    const cookies = document.cookie.split(';');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if (name !== 'lastUrl') {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    }
  }
  onValidateEmail(values) {
    if (this.validateEmailform.valid) {
      const email = values.Email;
      this.authService.userAlreadyExists(email).subscribe((res) => {
        if (res.body.data.isExists == true) {
          this.isUserAlredyExists = res.body.data.isExists;
          setTimeout(() => this.setFocus(), 0);
        } else {
          this.router.navigate(['/iadvl/register'], {
            queryParams: { email },
          });
        }
      });
    } else {
      validateAllFormFields(this.validateEmailform);
    }
  }
  onValidatePassword(values) {
    if (this.validatePasswordform.valid) {
      const data = {
        email: this.validateEmailform.value.Email.toLowerCase(),
        password: values.Password
      };
      this.authService.login(this.utilityService.removeEmpty(data)).subscribe((res) => {
        if (res.body.data) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(res.body.data.token);
          localStorage.setItem('token', res.body.data.token);
          localStorage.setItem('userId', decodedToken.data.id);
          localStorage.setItem('adminAuthority', decodedToken.data.isAdmin);
          localStorage.setItem('userName', decodedToken.data.firstName);
          this.setCookieAndNavigate(decodedToken.data.id, decodedToken.data.isAdmin, decodedToken.data.firstName);
          this.redirectTo();
        }

      },
        (err) => { }
      );
    } else {
      validateAllFormFields(this.validatePasswordform);
    }
  }
  redirectTo() {
    this.router.navigate(['/iadvl/application/mysubmissions']);
  }
  loginUsingOtp() {
    const journalId = this.iadvlConst.currentJournalId || AppConfig.Journal_ID;
    const info = {
      email: this.validateEmailform.value.Email.toLowerCase(),
      journalId
    };
    this.authService.sendotp(info).subscribe((res) => {
      if (res.body.data) {
        this.email = res.body.data.email;
        this.verification = res.body.data.verification
        this.isUserAlredyExists = null;
        this.isShowOtpVerifyScreen = true;
      }
    });

  }
  otpFromChanges() {
    this.oneTimePasswordFormGroup.valueChanges.subscribe((value) => {
      if (this.oneTimePasswordFormGroup.valid) {
        this.showInvalidOtp = false;
      } 
    });
  }
  public onSubmitOtpFormGroup(value) {
    if (this.oneTimePasswordFormGroup.valid) {
      this.showInvalidOtp = false;
      const otpInfo = {
        email: this.email,
        otp: `${value.input1}${value.input2}${value.input3}${value.input4}`,
        verification: this.verification
      };
      this.authService.loginotp(otpInfo).subscribe((res) => {
        if (res.body.data) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(res.body.data.token);
          localStorage.setItem('token', res.body.data.token);
          localStorage.setItem('userId', decodedToken.data.id);
          localStorage.setItem('adminAuthority', decodedToken.data.isAdmin);
          localStorage.setItem('userName', decodedToken.data.firstName);
          this.setCookieAndNavigate(decodedToken.data.id, decodedToken.data.isAdmin, decodedToken.data.firstName);
          this.redirectTo();
        }
      });
    } else {
      this.showInvalidOtp = true;
    }
  }
  openAboutMoodal() {
    this.aboutModal.config = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
    };
    this.aboutModal.show();
  }
  openSecretariatModal() {
    this.secretariatModal.config = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
    };
    this.secretariatModal.show();
  }
  otpOneCall(event: KeyboardEvent, index: number) {
    const inputElement = event.target as HTMLInputElement;
    const formElement = inputElement.form;
  
    if (!formElement) return; // Safety check
  
    if (event.code === 'Backspace' && this.hasNoValue(index)) {
      if (index > 0) {
        (formElement['otp' + (index - 1)] as HTMLInputElement).focus();
      }
    } else if (inputElement.value !== '') {
      if (index < 3) {
        (formElement['otp' + (index + 1)] as HTMLInputElement).focus();
      } else {
        // Move focus to the submit button when 4th OTP digit is entered
        this.focusSubmitButton();
      }
    }
  
    this.otpValues[index] = inputElement.value;
  }
  

  hasNoValue(index) {
    if (this.otpValues[index] || this.otpValues[index] === 0) return false;

    return true;
  }
  otpInputs(event, index) {
    if (event.target.value > 10) {
      event.target.value = event.target.value % 10;
    }
  }
  otpPaste(event, index) {
    event.preventDefault();
    this.clipData = event.clipboardData.getData('text/plain').split('');
    this.filldata(event.target.form, index);
  }

  filldata(form, index) {
    for (let i = index; i < 6; i++) {
      form['otp' + i].value = this.clipData.shift();
    }
  }
  onBack() {
    this.isUserAlredyExists = false;
    setTimeout(() => this.setFocus(), 0);
  }
  ngAfterViewInit() {
    this.setFocus();
  }
  private setFocus() {
    if (this.isUserAlredyExists == false) {
      this.textEmail?.nativeElement.focus();
    } else if (this.isUserAlredyExists == true) {
      this.textPassword?.nativeElement.focus();
    }
  }
  focusSubmitButton() {
    setTimeout(() => {
      const submitBtn = document.getElementById("otpSubmitBtn") as HTMLButtonElement;
      if (submitBtn) {
        submitBtn.focus(); // Move focus to submit button
      }
    }, 100); // Delay to ensure input processing is complete
  }
}
